// import clone from 'clone';
import actions from './actions';
const initState = {  
  warranties:[],
  isDelete:false,
};

export default function cardReducer(state = initState, { type, ...action }) {
  switch (type) {
    case actions.GET_WARRANTIES_REDUCER:
      return {
        ...state,             
        warranties: action.data,
        isDelete:false
      };
    case actions.DELETE_WARRANTY_SUCCESS:
      return {
        ...state,        
        isDelete: true
      };
    default:
      return state;
  }
}
